export const safelyParseJSON = (json: string): any[] => {
  let parsed: any[]
  try {
    parsed = JSON.parse(json) as any[]
  } catch (e) {
    parsed = []
  }
  return parsed
}
